var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.target(_vm.$mq))?_c('li',{class:Object.assign({}, _vm.getClass, {'on': _vm.isSameUrl}),on:{"click":_vm.menuAction}},[_c('a',[_vm._v(_vm._s(_vm.name))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }